import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  // BehaviorSubject pour suivre l'état du menu
  isOpen: boolean = false;
  private isMenuOpenSubject: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(this.isOpen);

  constructor() {}

  // Méthode pour obtenir la valeur actuelle de l'état du menu

  // Méthode pour obtenir l'observable de l'état du menu
  getIsMenuOpen(): Observable<boolean> {
    return this.isMenuOpenSubject.asObservable();
  }

  // Méthode pour basculer l'état du menu
  toggleMenu(): void {
    this.isOpen = !this.isOpen;
    this.isMenuOpenSubject.next(this.isOpen);
  }
}
